module.exports = __webpack_public_path__ + "img/authority.50ac0d68.svg";